import React from "react";
import Box from "@material-ui/core/Box";

interface Props {
  apiVersion?: {
    release: string;
    source: string;
  };
  frontendVersion?: {
    release: string;
    source: string;
  };
}
export const Footer = ({ apiVersion, frontendVersion }: Props): JSX.Element => {
  return (
    <Box p={4} display="flex" justifyContent="center" style={{ color: "#aaa", fontSize: 10 }}>
      Frontend: {frontendVersion?.release} - {frontendVersion?.source.substring(0, 7)}, API: {apiVersion?.release} -{" "}
      {apiVersion?.source.substring(0, 7)}
    </Box>
  );
};
